import { Component, OnInit, inject, ChangeDetectionStrategy } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { HeaderComponent } from "../header/header.component";
import { ButtonComponent } from "../button/button.component";
import { TranslatePipe } from "@ngx-translate/core";

// Använd inte direkt
// Denna används av DirtyFormService
@Component({
    selector: "rask-dirty-modal",
    templateUrl: "./dirty-modal.component.html",
    styleUrls: ["./dirty-modal.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        HeaderComponent,
        ButtonComponent,
        TranslatePipe
    ]
})
export class DirtyModalComponent implements OnInit {
    activeModal = inject(NgbActiveModal);

    header = "";
    content = "";
    showSave = false;

    ngOnInit(): void {
        setTimeout(() => {
            (document.querySelector("#cancel button") as unknown as HTMLElement).focus();
        }, 10);
    }
}
